<template>
  <div class="d-flex-row value_setter space-between gap-9">
    <button
      class="value_setter_button flex-25"
      @click="decrement"
      v-if="showButtons"
    >
      <MinusIcon />
    </button>
    <input
      class="value_setter_field font-family-2 flex-5 bold-xl"
      :class="[!showButtons && 'flex-10']"
      :type="$isMobile() ? 'text' : 'number'"
      :step="step"
      :value="displayValue"
      @input="enterValue"
      :min="min"
      :max="max"
      inputmode="numeric"
      @blur="onClickOutside"
      pattern="[0-9]*"
      ref="value_setter_ref"
    />
    <button
      class="value_setter_button flex-25"
      @click="increment"
      v-if="showButtons"
    >
      <PlusIcon />
    </button>
  </div>
</template>

<script>
import PlusIcon from "~/components/icons/PlusIcon.vue";
import MinusIcon from "~/components/icons/MinusIcon.vue";
export default {
  data() {
    return {
      valIsNan: false,
      timeout: null,
      displayValue: this.modelValue, // Track display value separately from modelValue
      userEditing: false,
    };
  },
  props: {
    modelValue: {
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    min: {
      default: 0,
    },
    max: {
      type: Number,
      default: 250000,
    },
    showButtons: {
      default: true,
    },
    enforceStepOnInput: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    // Update displayValue when modelValue changes externally
    modelValue: {
      handler(newVal) {
        if (!this.userEditing) {
          this.displayValue = newVal;
        }
      },
      immediate: true,
    },
  },

  methods: {
    increment() {
      if (this.value + this.step <= this.max) {
        this.$emit("update:modelValue", this.value + this.step);
      }
    },
    decrement() {
      if (this.value - this.step >= this.min) {
        this.$emit("update:modelValue", this.value - this.step);
      }
    },
    enterValue($event) {
      this.userEditing = true;
      // Store the current input value for display
      this.displayValue = $event.target.value;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        let value =
          $event.target.value.toString().indexOf(".") != -1
            ? parseFloat($event.target.value)
            : parseInt($event.target.value);

        if (isNaN(value)) {
          this.valIsNan = true;
          return;
        }

        if (value < this.min) {
          this.valIsNan = true;
          return;
        }
        if (value > this.max) {
          this.valIsNan = true;
          return;
        }

        this.valIsNan = false;
        if (this.enforceStepOnInput && this.step > 1) {
          const validValue = this.validateStepValue(value);
          this.displayValue = validValue; // Update display value
          this.$emit("update:modelValue", validValue);
        } else {
          this.$emit("update:modelValue", value);
        }
      }, 350);
    },

    validateStepValue(value) {
      if (isNaN(value)) {
        return this.min;
      }

      if (value < this.min) {
        return this.min;
      }

      if (value > this.max) {
        return this.max;
      }

      // Adjust to nearest step
      const remainder = (value - this.min) % this.step;
      if (remainder !== 0) {
        return (
          Math.round((value - this.min) / this.step) * this.step + this.min
        );
      }

      return value;
    },

    onClickOutside() {
      this.userEditing = false;

      // Handle NaN case
      if (this.valIsNan || isNaN(this.modelValue)) {
        this.valIsNan = false;
        const defaultValue = this.min;
        this.displayValue = defaultValue;
        this.$emit("update:modelValue", defaultValue);
        return;
      }

      const value = parseInt(this.modelValue);
      const correctedValue = this.validateStepValue(value);

      // Always update the display value and emit the corrected value
      this.displayValue = correctedValue;
      this.$emit("update:modelValue", correctedValue);
    },
  },

  computed: {
    value() {
      return this.modelValue ? parseInt(this.modelValue) : 0;
    },
  },
  components: {
    PlusIcon,
    MinusIcon,
  },
};
</script>
